import {
  PageValues,
  usePageContext,
} from '@providers/PageMetaProvider/model/PageContext.ts';
import { useEffect } from 'react';
import usePageTitle from '@hooks/usePageTitle/usePageTitle.ts';
import DocumentTemplateTable from '@features/admin-document-template/containers/DocumentTemplateTable';

const pageValues: PageValues = {
  title: 'Document Templates',
  description: 'Create and manage document templates',
};

function DocumentTemplatePage() {
  usePageTitle('ZlaytAI - Document Templates');
  const { setValues } = usePageContext();

  useEffect(() => {
    if (setValues) {
      setValues((prev) => ({
        ...prev,
        ...pageValues,
      }));
    }
  }, []);

  return <DocumentTemplateTable />;
}

export default DocumentTemplatePage;
